import { useEffect, useState } from "react";

const KEY = "basiq_admin_theme";
const CLS = "admin-light";

export const getAdminTheme = () => { try { return localStorage.getItem(KEY) === "light" ? "light" : "dark"; } catch { return "dark"; } };

export const applyAdminTheme = (theme) => {
  document.documentElement.classList.toggle(CLS, theme === "light");
  try { localStorage.setItem(KEY, theme); } catch {}
  window.dispatchEvent(new CustomEvent("basiq-admin-theme", { detail: theme }));
};

export const useAdminTheme = () => {
  const [theme, setTheme] = useState(getAdminTheme);
  useEffect(() => {
    applyAdminTheme(theme);
    const on = (e) => setTheme(e.detail);
    window.addEventListener("basiq-admin-theme", on);
    return () => window.removeEventListener("basiq-admin-theme", on);
  }, []); // eslint-disable-line
  const toggle = () => { const t = theme === "light" ? "dark" : "light"; setTheme(t); applyAdminTheme(t); };
  return { theme, toggle, isLight: theme === "light" };
};
